export const resetSidebar = () => {
    const elements = document.getElementsByClassName("menu-label");
    for (var i = 0; i < elements.length; i++) {
        elements[i].classList.remove("active");
    }
};
